module.exports = __webpack_public_path__ + "img/home16w.22f0453c.jpg";